import PropTypes from 'prop-types';
import React, { Fragment, Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Select from 'components/Select';
import * as http from 'utils/http';
import config from 'config';

import debouncePromise from 'debounce-promise';

import { Modal, Spacer, Button, Text, Flexer } from '@ontruck/orc';

import { Loading } from 'components/Loading';

import { isValidVehicleForJourney } from 'utils/filter';
import { vehiclesByPlate } from 'utils/sort';
import { DRIVER_STATES } from 'components/CarrierDetails/Constants';
import { IS_TENANT } from 'tenant/config';

const serialize = (obj) =>
  Object.entries(obj)
    .map(([key, val]) => (typeof val !== 'undefined' ? `${key}=${val}` : ''))
    .join('&');

class ShipmentModalAssignment extends Component {
  static propTypes = {
    show: PropTypes.bool,
    driver: PropTypes.any,
    vehicle: PropTypes.any,
    trailer: PropTypes.any,
    journey: PropTypes.any,
    intl: PropTypes.any,
    onClose: PropTypes.func,
    onAssign: PropTypes.func,
    renderInModal: PropTypes.bool,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    renderInModal: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      driver: props.driver ? props.driver : null,
      vehicle: props.vehicle ? props.vehicle : null,
      trailer: props.trailer ? props.trailer : null,
      loading: false,
    };
    this.handleChangeCB = this.handleChangeCB.bind(this);
    this.handleOnChangeDriver = this.handleOnChangeDriver.bind(this);
    this.getDrivers = debouncePromise(this.getDrivers.bind(this), 500, { leading: true });
    this.handleAssign = this.handleAssign.bind(this);
  }

  handleAssign() {
    const { onAssign } = this.props;

    const { driver, vehicle, trailer } = this.state;

    this.setState({ loading: true });

    const vehicles = [!!vehicle && vehicle.url, !!trailer && trailer.url].filter(
      (notnull) => notnull
    );

    onAssign({
      driver: (driver || {}).url,
      vehicle: null,
      vehicles,
    }).then(() => this.setState({ loading: false }));
  }

  handleOnChangeDriver(value) {
    this.setState(
      {
        driver: value,
        vehicle: null,
        trailer: null,
      },
      this.handleChangeCB
    );
  }

  filterDrivers(route) {
    return ({ routes }) => {
      return (
        !route ||
        (route &&
          routes &&
          routes
            .map(({ origin, destination }) => `${origin}-${destination}`)
            .includes(`${route.origin}-${route.destination}`))
      );
    };
  }

  async getDrivers(input) {
    const { driver = null, route = null } = this.props;

    if (!input || input.length < 3) {
      return Promise.resolve({ options: (!!driver && [driver]) || [] });
    }

    const params = {
      search: input,
      page_size: 0,
      ordering: 'user__first_name,user__last_name',
      route: !route ? undefined : `${route.origin}->${route.destination}`,
      status: DRIVER_STATES.active,
    };

    const options = await http.get(`${config.API_URL}mercury/drivers/?${serialize(params)}`);

    return Promise.resolve({ options });
  }

  checkValidVehicle() {
    const { journey } = this.props;
    return (journey && isValidVehicleForJourney(journey)) || (() => false);
  }

  getVehicles({ label, filter = () => true }) {
    const { driver } = this.state;

    const { vehicles = [] } = driver || {};

    return [
      {
        label,
        value: null,
        checkbox: false,
        object: null,
      },
    ]
      .concat(
        (vehicles || []).filter(filter).map((vehicle) => ({
          value: vehicle.url,
          label: vehicle.plate_number,
          checkbox: this.checkValidVehicle()(vehicle),
          object: vehicle,
        }))
      )
      .sort(vehiclesByPlate);
  }

  vehicleOptionRenderer({ label, checkbox }) {
    return (
      <span>
        {label}
        {checkbox ? (
          <span role="img" aria-label="Valid vehicle">
            &nbsp;&nbsp;&#x2705;
          </span>
        ) : null}
      </span>
    );
  }

  handleChangeCB() {
    const { onChange } = this.props;

    if (!onChange) {
      return;
    }

    const { driver, vehicle, trailer } = this.state;

    const vehicles = [!!vehicle && vehicle.url, !!trailer && trailer.url].filter(
      (notnull) => notnull
    );

    onChange({
      driver: (driver || {}).url,
      vehicle: null,
      vehicles,
    });
  }

  renderContent() {
    const { intl, renderInModal } = this.props;

    const { driver, vehicle, trailer, loading } = this.state;

    const t = intl.messages.components.ShipmentModalAssignment;
    const { is_blocked, carrier, is_active } = driver || {};
    const { is_blocked: carrierIsBlocked, name: carrierName } = carrier || {};

    return (
      <Fragment>
        {driver && (is_blocked || carrierIsBlocked || !is_active) && (
          <Spacer mBottom="S">
            <Text color="redCherry">
              {carrierIsBlocked ? t.inactive_carrier : t.inactive_driver}
            </Text>
          </Spacer>
        )}
        <Flexer.Parent
          {...((renderInModal && {
            flexDirection: 'column',
          }) || {
            justifyContent: 'space-between',
          })}
        >
          <Flexer.Child
            {...((renderInModal && {
              mBottom: 'S',
            }) || {
              mRight: 'S',
            })}
            flex="1"
            data-e2e="assignment_modal__driver"
          >
            <Select
              async
              placeholder={t.driver_placeholder}
              cache={false}
              ignoreAccents={false}
              ignoreCase={true}
              multi={false}
              value={driver}
              onChange={this.handleOnChangeDriver.bind(this)}
              loadOptions={this.getDrivers}
              valueKey="url"
              labelKey="contact_name"
              disabled={loading}
              small
            />
            {carrierName ? (
              <Spacer mTop="S">
                {t.carrier} {carrierName}
              </Spacer>
            ) : null}
          </Flexer.Child>
          <Flexer.Child
            {...((renderInModal && {
              mBottom: 'S',
            }) || {
              mRight: 'S',
            })}
            flex="1"
            data-e2e="assignment_modal__vehicle"
          >
            <Select
              clearable={false}
              placeholder={t.vehicle_placeholder}
              ignoreCase={true}
              matchPos="any"
              value={vehicle && vehicle.url}
              optionRenderer={this.vehicleOptionRenderer}
              options={this.getVehicles({
                label: t.vehicle_placeholder,
                filter: ({ is_active }) => is_active,
              })}
              onChange={(option) => {
                this.setState({ vehicle: option.object, trailer: null }, this.handleChangeCB);
              }}
              disabled={loading || !driver}
              small
            />
          </Flexer.Child>
          <Flexer.Child
            {...(renderInModal && {
              mBottom: 'S',
            })}
            flex="1"
            data-e2e="assignment_modal__trailer"
          >
            <Select
              clearable={false}
              placeholder={IS_TENANT ? t.platform_label : t.trailer_placeholder}
              ignoreCase={true}
              matchPos="any"
              value={trailer && trailer.url}
              options={this.getVehicles({
                label: t.vehicle_placeholder,
                filter: ({ is_active }) => is_active,
              })}
              onChange={(option) => {
                this.setState({ trailer: option.object }, this.handleChangeCB);
              }}
              disabled={
                loading || !vehicle || (!!vehicle && vehicle.vehicle_type !== 'tractor_unit')
              }
              small
            />
          </Flexer.Child>
        </Flexer.Parent>
        {renderInModal && loading && (
          <Spacer mBottom="S">
            <Loading />
          </Spacer>
        )}
        {renderInModal && (
          <Button
            fullWidth
            disabled={!driver || loading}
            text={t.save_button}
            onClick={this.handleAssign}
          />
        )}
      </Fragment>
    );
  }

  render() {
    const { show, intl, onClose, renderInModal } = this.props;

    const t = intl.messages.components.ShipmentModalAssignment;

    if (renderInModal) {
      return (
        <Modal
          show={show}
          onClose={onClose}
          headerComponent={t.title}
          size="S"
          visibleOverflow={true}
        >
          {this.renderContent()}
        </Modal>
      );
    }

    return this.renderContent();
  }
}

export default injectIntl(connect(null)(ShipmentModalAssignment));
